export enum ECoinInputType {
    FROM = 'from',
    TO = 'to',
}

export const CoinInputType = {
    FROM: ECoinInputType.FROM,
    TO: ECoinInputType.TO,
}
